import { isNotNullOrUndefined } from '../../utility/null-safety.js';
import { Component } from '../core/component.js';

export abstract class NoteComponentBase extends Component {
  constructor(
    public readonly note: string,
  ) {
    super();
  }

  get hasNote(): boolean {
    return isNotNullOrUndefined(this.note) && this.note.length > 0;
  }
}
